import axios from 'axios';
import config from '../config';

const api = axios.create({
  baseURL: `${config.apiBaseUrl}/`,
});

export default api;



// WEBPACK FOOTER //
// ./src/services/api.js